
export interface menu {
  header?: string;
  title?: string;
  icon?: string;
  to?: string;
  divider?: boolean;
  getURL?: boolean;
  chip?: string;
  chipColor?: string;
  chipVariant?: string;
  chipIcon?: string;
  children?: menu[];
  disabled?: boolean;
  type?: string;
  subCaption?: string;
  isCustom?: boolean;
  customActiveTab?: string;
}

const commonSharedProp: menu = {
  isCustom: true,
  customActiveTab: 'custom-active-smc'
}

const sidebarItem: menu[] = [
  {
    ...commonSharedProp,
    title: 'Dashboard',
    icon: 'mdi-view-dashboard',
    to: '/dashboard',
  },

  {
    ...commonSharedProp,
    title: 'Site',
    icon: 'mdi-slope-downhill',
    customActiveTab: 'custom-active-slope',
    children: []
  },

  {
    ...commonSharedProp,
    title: 'Device Status',
    icon: 'mdi-router-wireless',
    to: '/devices',
  },
  {
    ...commonSharedProp,
    title: 'Slope Analysis',
    icon: 'mdi-chart-line',
    to: '/analysis',
  },
    {
    ...commonSharedProp,
    title: 'Monitoring Config',
    icon: 'mdi-cog',
    to: '/monitor-config',
  },

];

export default sidebarItem;
